import { useMemo } from "react";

import { RenewalFilterByStatus } from "@covertree/agent-portal-graphql";
import { useAccessPattern } from "@hooks/useAccessPattern";

export const useGetRenewalsFilters = () => {
  const { canSeeDiscardedRenewals } = useAccessPattern();

  return useMemo(
    () => [
      {
        label: RenewalFilterByStatus.All,
        value: RenewalFilterByStatus.All,
      },
      {
        label: "Upcoming",
        value: RenewalFilterByStatus.UpcomingRenewals,
      },
      {
        label: "UW Review",
        value: RenewalFilterByStatus.UwReview,
      },
      {
        label: "UW Accepted",
        value: RenewalFilterByStatus.RenewalUwAccepted,
      },
      {
        label: "Offer Sent",
        value: RenewalFilterByStatus.OfferSent,
      },
      {
        label: RenewalFilterByStatus.Failed,
        value: RenewalFilterByStatus.Failed,
      },
      {
        label: "Issued",
        value: RenewalFilterByStatus.RenewalIssued,
      },
      {
        label: "Non-Renewal Issued",
        value: RenewalFilterByStatus.NonRenewalIssued,
      },
      ...(canSeeDiscardedRenewals
        ? [
            {
              label: "Discarded",
              value: RenewalFilterByStatus.DiscardedRenewals,
            },
          ]
        : []),
    ],
    [canSeeDiscardedRenewals]
  );
};
